// src/components/ChartContainer.js
import React from 'react';

const ChartContainer = ({ title, children }) => {
  return (
    <div className="chart-container">
      <h2 className="chart-title">{title}</h2>
      <div className="chart-content">
        {children}
      </div>
    </div>
  );
};

export default ChartContainer;